import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthContext';
import { employeeApi } from '../api/hr';

/**
 * The persistent identity/context strip - genuinely real data only.
 * Uses the existing GET /api/employees/me endpoint (built for the HR
 * self-service profile), not a new one invented for this component.
 * A user with no employee record (e.g. some Admin-only accounts, or
 * Partner accounts elsewhere in the app) genuinely has no
 * department/position to show - the banner falls back to name/email
 * only rather than showing an error or fabricated placeholder text.
 */
export function ContextBanner() {
  const { user } = useAuth();
  const employeeQuery = useQuery({
    queryKey: ['context-banner-employee'],
    queryFn: () => employeeApi.getMe(),
    retry: false, // a 404 here is a real, expected case (no employee record) - not worth retrying
  });

  if (!user) return null;
  const employee = employeeQuery.data?.data;

  return (
    <div className="context-banner">
      <span className="context-banner-org">VERDANTRISE HUMANITARIAN INITIATIVE</span>
      <span className="context-banner-detail">
        {employee ? (
          <>
            {employee.full_name}
            {employee.staff_id && ` · ${employee.staff_id}`}
            {employee.position_name && ` · ${employee.position_name}`}
            {employee.department_name && ` · ${employee.department_name}`}
          </>
        ) : (
          user.fullName
        )}
      </span>
    </div>
  );
}
